import React from 'react';
import { useTranslation } from 'react-i18next';
import {SEARCH_OPERATION_MODEL} from "../../Model/Model";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const ConnectorToggle = ({ connector, onChange }) => {
    const { t } = useTranslation();
    return (
        <div className="d-flex align-items-center w-100">
            <div className={"flex-fill border-top h-1px background-shades-100"}/>
            <div className="mx-3">
                <div className="d-flex justify-content-center align-items-center background-shades-100 my-2 border-radius-8px py-1 px-2">
                    <button
                        id={"btn_ct_and"}
                        className={`border-radius-8px border-0 fs-13px ibl-font-w-600 py-1 px-2 ${connector === SEARCH_OPERATION_MODEL.AND ? 'background-general-00' : 'background-shades-100'}`}
                        onClick={() => onChange(SEARCH_OPERATION_MODEL.AND)}
                    >
                        {t('and')}
                    </button>
                    <button
                        id={"btn_ct_or"}
                        className={`border-radius-8px border-0 fs-13px ibl-font-w-600 py-1 px-2 ${connector === SEARCH_OPERATION_MODEL.OR ? 'background-general-00' : 'background-shades-100'}`}
                        onClick={() => onChange(SEARCH_OPERATION_MODEL.OR)}
                    >
                        {t('or')}
                    </button>
                </div>
            </div>

            <div className={"flex-fill border-top h-1px background-shades-100"}/>
        </div>
    );
};

export default ConnectorToggle;
